import { useMutation, useQueryClient } from 'react-query';
import { saveRosterStateSettings } from 'RestAPIs/roster/state-settings';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

type RecurrenceRange = {
  type: 'NO_END' | 'BY_DATE' | 'BY_OCCURRENCES';
  end: string | null;
  numberOfOccurrences: number | null;
};

type RecurrenceRule = {
  start: string;
  periodType?: 'MONTH' | 'WEEK';
  interval?: number;
  dayOfMonth?: number | null;
  dayInWeekSet?: string[];
  setPosition?: number | null;
  recurrenceRange?: RecurrenceRange;
};

type PlanningCycleRound = {
  startIndex: number;
  endIndex: number;
  autoConnect: boolean;
};

type RosterStateSettingsValues = {
  costCenterId: number;
  planningCyclePayload: {
    rosterState: 'PUBLISHED' | 'VISIBLE';
    enabled: boolean;
    recurrenceRule?: RecurrenceRule | null;
    cycleWindow?: number | null;
    rounds?: PlanningCycleRound[];
  };
};

const useSaveRosterStateSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RosterStateSettingsValues>(
    ({ costCenterId, planningCyclePayload }) =>
      saveRosterStateSettings({ costCenterId, planningCyclePayload }),
    {
      onSuccess: (costCenterId, planningCyclePayload) => {
        queryClient.invalidateQueries([
          'rosterStateSettings',
          costCenterId,
          planningCyclePayload
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useSaveRosterStateSettings;
